module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe1_cn@3x.fe18ed8b.png";